/* eslint-disable */
import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import styled from "styled-components";

const Wrap = styled.footer`
  background:#787c88;
  color:#E9EEF8;
  padding:20px 16px 28px;
  border-top:1px solid rgba(255,255,255,.06);
`;

/* 상단 링크 영역 (항상 노출) */
const Links = styled.nav`
  display:flex;
  flex-wrap:wrap;
  align-items:center;
  gap:12px 18px;

  a{
    color:#F4F7FF;
    font-weight:800;
    text-decoration:none;
    font-size:14px;
    letter-spacing:-0.2px;
    opacity:.95;
    cursor:pointer;
  }

  @media (max-width: 480px){
    a{ font-size:13px; }
  }
`;

const Divider = styled.hr`
  margin:14px 0 10px;
  border:0;
  height:1px;
  background:rgba(255,255,255,.12);
`;

/* 사업자 정보 토글 줄 */
const ToggleRow = styled.button`
  width:100%;
  display:flex;
  align-items:center;
  justify-content:space-between;
  padding:8px 0 4px;
  background:transparent;
  border:0;
  color:#E2E8F7;
  font-size:13px;
  font-weight:800;
  cursor:pointer;
  text-align:left;

  span.label{
    overflow:hidden;
    text-overflow:ellipsis;
    white-space:nowrap;
  }

  span.icon{
    flex-shrink:0;
    width:26px;
    height:26px;
    border-radius:999px;
    background:rgba(0,0,0,.25);
    display:flex;
    align-items:center;
    justify-content:center;
    font-size:15px;
    margin-left:10px;
  }
`;

const Company = styled.div`
  margin-top:8px;
  color:#D7DFF0;
  line-height:1.6;
  font-size:13px;
  font-weight:700;

  b{
    font-weight:900;
    color:#FFFFFF;
  }
`;

const Copy = styled.div`
  margin-top:10px;
  color:#BFD0F3;
  font-size:12px;
`;

// ✅ 네이버 블로그 URL (모바일 버전)
const NAVER_BLOG_URL = "https://m.blog.naver.com/heyway_officia";

// ✅ 앱(WebView)로 메시지 보내는 헬퍼
const sendToNative = (payload) => {
  try {
    if (typeof window === "undefined") return;
    if (!window.ReactNativeWebView) return;
    window.ReactNativeWebView.postMessage(JSON.stringify(payload));
  } catch (e) {
    // 앱 쪽 통신 실패해도 웹 동작에 영향 없게 조용히 무시
    console.warn("[FooterCompanyInfo] postMessage error:", e);
  }
};

export default function FooterCompanyInfo({
  company = "주식회사 DH모빌리티",
  ceo = "한영철",
  biznum = "298-81-01624",
  address = "경기도 화성시 동탄영천로 150 현대실리콘앨리 A동 13층",
  tel = "070-4439-8015",
  links = [
    { label: "이용약관", href: "/terms" },
    { label: "개인정보처리방침", href: "/privacy" },
    { label: "이메일주소 무단수집 거부", href: "/no-email-harvest" },
    { label: "NAVER 공식블로그", href: "/naver-blog" },
  ],
}) {
  const [open, setOpen] = useState(false);
  const nav = useNavigate();

  const labelText = open
    ? `${company} 사업자 정보`
    : "";

  const handleLinkClick = (href) => (e) => {
    e.preventDefault();

    // ✅ 네이버 블로그만 특수 처리
    if (href === "/naver-blog") {
      if (typeof window !== "undefined" && window.ReactNativeWebView) {
        // 앱(WebView) 안: 네이티브에게 "외부 브라우저로 열어줘" 요청
        sendToNative({
          type: "OPEN_EXTERNAL_URL",
          url: NAVER_BLOG_URL,
          source: "footer_naver_blog",
        });
      } else {
        // 브라우저: 기존처럼 새 탭 팝업
        window.open(NAVER_BLOG_URL, "_blank", "noopener,noreferrer");
      }
      return;
    }

    // ✅ 나머지 링크는 SPA 내 라우팅
    nav(href);
  };

  return (
    <Wrap>
      {/* 항상 보이는 링크들 */}
      <Links aria-label="푸터 링크">
        {links.map((l, i) => (
          <a
            key={i}
            href={l.href}
            onClick={handleLinkClick(l.href)}
          >
            {l.label}
          </a>
        ))}
      </Links>

      <Divider />

      {/* 당근식 사업자 정보 토글 */}
      <ToggleRow
        type="button"
        onClick={() => setOpen((v) => !v)}
        aria-expanded={open}
        aria-label={`${company} 사업자 정보 ${open ? "접기" : "펼치기"}`}
      >
        <span className="label">{labelText}</span>
        <span className="icon">{open ? "▴" : "▾"}</span>
      </ToggleRow>

      {open && (
        <>
          <Company>
            <div>
              <b>{company}</b> | 대표이사: {ceo} | 사업자등록번호: {biznum}
            </div>
            <div>
              주소: {address} | 대표전화: {tel}
            </div>
          </Company>

          <Copy>
            © {new Date().getFullYear()} DH모빌리티 Inc. All rights reserved.
          </Copy>
        </>
      )}
    </Wrap>
  );
}
